import { Model } from 'pinia-orm';

export default class DataRetentionExtensionRequest extends Model {

    static get entity () {
        return 'data-retention-extension-requests';
    }

    static fields () {
        return {
            id: this.uid(() => null),
            application_id: this.attr(null),
            outbound_email_id: this.attr(null),
            extension_period: this.attr(null),
            accepted_at: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
        }
    }
}
